<template>
	<div v-if="aiList.length && shopId > 0" class="robot-select" :style="styleObj">
		<el-select v-model="value" placeholder="请选择">
			<el-option v-for="item in aiList" :key="item.aiSetting" :label="item.name" :value="item.aiSetting"></el-option>
		</el-select>
	</div>
</template>

<script>
export default {
	name: 'robotSelect',
	data () {
		return {
			value: '',
			aiList: [],
			setSwitch: true
		}
	},
	props: ['styleObj', 'shopId', 'sessionId'],
	watch: {
		shopId () {
			if (!this.shopId || this.shopId == -1) return;
			this.getAIRobotList({
				serviceType: this.$store.state.currentShop.serviceType,
				shopId: this.$store.state.currentShop.id,
				customerId: this.$store.state.userInfo.id
			});
		},
		sessionId () {
			if (!this.sessionId) return;
			if (!this.$store.state.conversationType) {
				this.getAIRobotList({
					serviceType: this.$store.state.currentShop.serviceType,
					shopId: this.$store.state.currentShop.id,
					sessionId: this.sessionId
				});
			} else {
				this.aiList = [];
			}
		},
		value () {
			if (this.setSwitch) this.setAIRobot();
			this.setSwitch = true;
		}
	},
	methods: {
		// 获取AI列表
		getAIRobotList (data) {
			var self = this;

			self.aiList = [];
			self.$axios.post(API_ROOT.url + '/AISettingsApi.getAISettings', data).then(result => {
				if (result.status) {
					self.aiList = result.data;
					if (!self.aiList.length) return;
					for (var i = 0; i < self.aiList.length; i++) {
						if (self.aiList[i].select && self.value != self.aiList[i].aiSetting) {
							self.setSwitch = false;
							self.value = self.aiList[i].aiSetting;
							break;
						}
					}
				} else {
					self.$alert('获取AI列表错误，错误原因：' + result.msg);
				}
			}, response => {
				if (response) {
					self.$alert('获取AI列表错误，错误码(' + response + ')');
				} else {
					self.$alert('获取AI列表错误。您的网络不稳定，请稍后再试！');
				}
			});
		},

		// 设置AI机器人
		setAIRobot () {
			var self = this;

			if (self.sessionId) {
				var data = {
					serviceType: self.$store.state.currentShop.serviceType,
					aiSetting: {
						startTimestamp: new Date().getTime(),
						sessionId: self.sessionId,
						aiSetting: self.value
					}
				};
			} else {
				var data = {
					serviceType: self.$store.state.currentShop.serviceType,
					aiSetting: {
						startTimestamp: new Date().getTime(),
						shopId: self.$store.state.currentShop.id,
						customerId: self.$store.state.userInfo.id,
						aiSetting: self.value
					}
				};
			}

			self.$axios.post(API_ROOT.url + '/AISettingsApi.setAISetting', data).then(result => {
				if (!result.status) {
					self.$alert('设置AI机器人失败，失败原因：' + result.msg);
				}
			}, response => {
				self.$alert('设置AI机器人失败，错误码(' + response + ')');
			});
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/robotSelect.vue